import { AppDomainConstant } from '../app-domain.constant';

export class ConfiguracionUsuarioAPIConstant {

  static readonly URL_GESTION_USUARIOS: string = 'api/v1/users-management/';
  static readonly REESTABLECER_CONTRASENA: string = ConfiguracionUsuarioAPIConstant.URL_GESTION_USUARIOS + 'credentials/forget-password';
  static readonly CAMBIAR_CONTRASENA: string = ConfiguracionUsuarioAPIConstant.URL_GESTION_USUARIOS + 'credentials/change-password';
  static readonly RENOVAR_CONTRASENA: string = ConfiguracionUsuarioAPIConstant.URL_GESTION_USUARIOS + 'credentials/new-password';
  static readonly RESET_SOFTWARE_TOKEN: string = ConfiguracionUsuarioAPIConstant.URL_GESTION_USUARIOS + 'credentials/reset-software-token';

    static readonly URL_REESTABLECER_CONTRASENA: string =
    AppDomainConstant.URI_GATEWAY +
    ConfiguracionUsuarioAPIConstant.REESTABLECER_CONTRASENA;

    static readonly URL_CAMBIAR_CONTRASENA: string =
    AppDomainConstant.URI_GATEWAY +
    ConfiguracionUsuarioAPIConstant.CAMBIAR_CONTRASENA;

    static readonly URL_RENOVAR_CONTRASENA: string =
    AppDomainConstant.URI_GATEWAY +
    ConfiguracionUsuarioAPIConstant.RENOVAR_CONTRASENA;

    static readonly URL_RESET_SOFTWARE_TOKEN: string =
    AppDomainConstant.URI_GATEWAY +
    ConfiguracionUsuarioAPIConstant.RESET_SOFTWARE_TOKEN;
}
